"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleset = undefined;

var _util = require("../../../../util");

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var TS0 = Util.Timestamp.wrap(0);
var ruleset = exports.ruleset = { isVoid: true };
exports.default = [{
  name: "void",
  ruleset: ruleset,
  lifecycle: {
    visibleAt: TS0,
    openAt: TS0
  }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L3ZvaWQuanMiXSwibmFtZXMiOlsiVXRpbCIsIlRTMCIsIlRpbWVzdGFtcCIsIndyYXAiLCJydWxlc2V0IiwiaXNWb2lkIiwibmFtZSIsImxpZmVjeWNsZSIsInZpc2libGVBdCIsIm9wZW5BdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztJQUFZQSxJOzs7O0FBR1osSUFBTUMsTUFBTUQsS0FBS0UsU0FBTCxDQUFlQyxJQUFmLENBQW9CLENBQXBCLENBQVo7QUFFTyxJQUFNQyw0QkFBbUIsRUFBQ0MsUUFBUSxJQUFULEVBQXpCO2tCQUNTLENBQ2Q7QUFDRUMsUUFBTSxNQURSO0FBRUVGLGtCQUZGO0FBR0VHLGFBQVc7QUFDVEMsZUFBV1AsR0FERjtBQUVUUSxZQUFRUjtBQUZDO0FBSGIsQ0FEYyxDIiwiZmlsZSI6InZvaWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0ICogYXMgVXRpbCBmcm9tIFwiLi4vLi4vLi4vLi4vdXRpbFwiXG5pbXBvcnQgdHlwZSB7U3RhdGUgYXMgTGVhZ3VlfSBmcm9tIFwiLi4vcmF3XCJcbmltcG9ydCB0eXBlIHtTdGF0ZSBhcyBSdWxlc2V0fSBmcm9tIFwiLi4vcnVsZXNldHNcIlxuY29uc3QgVFMwID0gVXRpbC5UaW1lc3RhbXAud3JhcCgwKVxuXG5leHBvcnQgY29uc3QgcnVsZXNldDogUnVsZXNldCA9IHtpc1ZvaWQ6IHRydWV9XG5leHBvcnQgZGVmYXVsdCAoW1xuICB7XG4gICAgbmFtZTogXCJ2b2lkXCIsXG4gICAgcnVsZXNldCxcbiAgICBsaWZlY3ljbGU6IHtcbiAgICAgIHZpc2libGVBdDogVFMwLFxuICAgICAgb3BlbkF0OiBUUzAsXG4gICAgfSxcbiAgfSxcbl06IExlYWd1ZVtdKVxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/leagues/list/void.js
// module id = 782
// module chunks = 0